<script setup lang="ts">
import logo from '@/assets/images/onenetwork_logo_bo.svg'
import bgLogin from '@/assets/loginbg.png'
</script>

<template>
  <div
    class="flex flex-2 h-[100vh] px-[10vw] justify-center items-end flex-col relative overflow-hidden"
    style="border-right: 1px solid #ebebeb"
  >
    <img :src="logo" alt="logo" width="200px" />
    <h4 class="font-bold uppercase text-xl text-right mt-5 mb-3">Quản trị Back Office</h4>
    <h1 class="font-bold text-3xl text-right" style="color: #ff6f00">
      Hệ Sinh Thái Giao Dịch BDS <br />One Network
    </h1>
    <br /><br /><br />
    <img :src="bgLogin" class="absolute md:w-[30vw] bottom-0 right-[-50px]" />
  </div>
</template>
